import { mdiArchiveOutline, mdiArchiveArrowUpOutline } from "@mdi/js"
import {
  CUSTOMER_REGISTRY_ACTION_TOOLTIP_CLASS,
  customerRegistryActionTooltips,
} from "../../../../../_shared/_logic/customer-registry-action-tooltips"
import type { CustomerRow } from "../_shared/_logic/customers-table-contract"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"

export default function buildRowActions({
  row,
  mutating = false,
  onMutate,
}: {
  row: CustomerRow
  mutating?: boolean
  onMutate: (row: CustomerRow) => void | Promise<void>
}): TableRowAction[] {
  const actions: TableRowAction[] = []

  actions.push({
    id: "action-0",

    label: row.customer.archived_at ? "Wiederherstellen" : "Archivieren",
    onClick: () => {
      void onMutate(row)
    },
    icon: row.customer.archived_at ? mdiArchiveArrowUpOutline : mdiArchiveOutline,
    disabled: mutating,
    tooltip: row.customer.archived_at
      ? customerRegistryActionTooltips.customerRestore
      : customerRegistryActionTooltips.customerArchive,
  })

  return actions
}
